import { configureStore } from "@reduxjs/toolkit";
import customersReducer from "../features/customers/customersSlice";
import rolesReducer from "../features/roles/rolesSlice";
import staffReducer from "../features/staff/staffSlice";
import organisationSlice from "../features/organization/organisationsSlice";
import businessUnitsSlice from "../features/businessUnit/businessUnitsSlice";
import departmentsReducer from "../features/department/departmentsSlice";
import contractsReducer from "../features/contract/contractSlice";
import providerRegistryReducer from "../features/organization/providerRegistrySlice";
import settingDefinitionReducer from "../features/organization/settingDefinationSlice";
import organiationSettingsReducer from "../features/organization/organisationSettingsSlice";
import organiationSecretReducer from "../features/organization/organizationSecretSlice";
import entityTypeReducer from "../features/contract/entityTypeSlice";
import templateReducer from "../features/template/templateSlice";
import partyReducer from "../features/party/partySlice";
import contractTitleReducer from "../features/contractTitle/contractTitleSlice";
import contractCategoriesReducer from "../features/contractCategories/contractCategoriesSlice";
import contractTypeReducer from "../features/contractType/contractTypeSlice";
import clauseTypeReducer from "../features/clauseType/clauseTypeSlice";
import jurisdictionReducer from "../features/jurisdiction/jurisdictionSlice";
import emailTemplateReducer from "../features/emailTemplate/emailTemplateSlice";
import noticeTemplateReducer from "../features/noticeTemplate/noticeTemplateSlice";
import receivablesReducer from "../features/receivables/receivablesSlice";
import obligationReducer from "../features/obligations/obligationSlice";

export const store = configureStore({
  reducer: {
    customers: customersReducer,
    roles: rolesReducer,
    staff: staffReducer,
    organisations: organisationSlice,
    businessUnits: businessUnitsSlice,
    departments: departmentsReducer,
    contracts: contractsReducer,
    providerRegistry: providerRegistryReducer,
    settingDefinitions: settingDefinitionReducer,
    organisationSettings: organiationSettingsReducer,
    organisationSecret: organiationSecretReducer,
    entityTypes: entityTypeReducer,
    template: templateReducer,
    party: partyReducer,
    contractTitles: contractTitleReducer,
    contractCategories: contractCategoriesReducer,
    contractTypes: contractTypeReducer,
    clauseTypes: clauseTypeReducer,
    jurisdictions: jurisdictionReducer,
    emailTemplates: emailTemplateReducer,
    noticeTemplates: noticeTemplateReducer,
    receivables: receivablesReducer,
    obligations: obligationReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
